import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	theatreModeOn: {
		position : "relative",
		height   : "inherit"
		// background : "#fff"
	},
	theatreModeOff: {
		marginLeft : props?.noLeftMargin ? 0 : "1rem",
		position   : "relative",
		overflow   : "hidden",
		height     : props?.isFromLayout ? "100%" : "calc((80vw - 100px)/ 1.77 + 56px)",
		background : theme.other.colors.background.secondary,

		[rooterMediaQuery.mobile]: {
			background: theme.other.colors.dialog.secondary
		}
	},
	cardWrapper: {
		height   : "100%",
		position : "relative",
		overflow : "hidden",
		width    : "300px"
	},
	theatreView: {
		width: "100%"
	},
	theatreViewPopOut: {
		width: "100%"
	},
	chatBottomContainer: {
		zIndex: 500
	},
	scrollToBottom: {
		display        : "flex",
		scale          : props?.showScrollBtn ? "1" : "0.2",
		opacity        : props?.showScrollBtn ? "1" : "0",
		transition     : "all 0.1s ease-in-out",
		width          : "100%",
		position       : "absolute",
		zIndex         : 5,
		justifyContent : "center",
		alignItems     : "center",
		marginBottom   : "10px",
		fontSize       : "1rem",
		marginTop      : "-40px"
	},
	downArrowIcon: {
		transform : "rotate(90deg)",
		width     : "1.5rem"
	},
	newComment: {
		display      : "flex",
		padding      : "4px 10px",
		fontWeight   : "500",
		color        : "white",
		cursor       : "pointer",
		borderRadius : "15px",
		alignItems   : "center",
		background   : "linear-gradient(to top, #439aff, #126bd5)"
	}
} ) );
